import React, { Component, PropTypes } from 'react';
import './UserAvatar.css';

class UserAvatar extends Component {
  render() {
    const { user, wrapperClassName } = this.props;
    const { avatar } = user;

    let avatarUrl = avatar ? avatar : '/assets/img/default-avatar.png';

    let wrapperClass = 'UserAvatar';
    if (wrapperClassName) {
      wrapperClass = wrapperClassName;
    }

    return (
      <div className={wrapperClass}>
        <img src={avatarUrl} className="UserAvatar__img" alt="" />
      </div>
    );
  }
};

UserAvatar.propTypes = {
  user: PropTypes.object.isRequired
};

export default UserAvatar;



// WEBPACK FOOTER //
// ./src/components/UserAvatar.js